import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="shell">
      <form class="card" #loginForm="ngForm" (ngSubmit)="submit()">
        <p class="brand">MicroKosm Voice</p>
        <h1>Admin sign in</h1>
        <p class="sub">Internal campaign control for MicroKosm</p>
        <label>Email</label>
        <input
          [(ngModel)]="email"
          name="email"
          type="email"
          autocomplete="username"
          required
          placeholder="admin@microkosm.com"
        />
        <label>Password</label>
        <input [(ngModel)]="password" name="password" type="password" autocomplete="current-password" required />
        <p class="err" role="alert" *ngIf="error">{{ error }}</p>
        <button type="submit" [disabled]="busy || loginForm.invalid">{{ busy ? 'Signing in…' : 'Sign in' }}</button>
      </form>
    </div>
  `,
  styles: [
    `
      .shell {
        min-height: 100vh;
        display: grid;
        place-items: center;
        background: radial-gradient(circle at top left, #1d4f4a, #0b1220 55%);
        padding: 24px;
      }
      .card {
        width: min(420px, 100%);
        background: rgba(255, 255, 255, 0.96);
        border-radius: 18px;
        padding: 28px;
        display: grid;
        gap: 10px;
        box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
      }
      .brand {
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-size: 12px;
        color: #0f766e;
        margin: 0;
        font-weight: 700;
      }
      h1 {
        margin: 0;
        font-family: Georgia, 'Times New Roman', serif;
        font-size: 2rem;
      }
      .sub {
        margin: 0 0 8px;
        color: #64748b;
      }
      input {
        border: 1px solid #cbd5e1;
        border-radius: 10px;
        padding: 10px 12px;
      }
      button {
        margin-top: 8px;
        border: 0;
        border-radius: 10px;
        background: #0f766e;
        color: white;
        padding: 12px;
        font-weight: 600;
        cursor: pointer;
      }
      .err {
        color: #b91c1c;
        margin: 0;
      }
    `,
  ],
})
export class LoginPage {
  email = '';
  password = '';
  error = '';
  busy = false;
  constructor(private readonly auth: AuthService, private readonly router: Router) {}
  async submit(): Promise<void> {
    if (this.busy || !this.email.trim() || !this.password) return;
    this.busy = true;
    this.error = '';
    try {
      await this.auth.login(this.email.trim(), this.password);
      await this.router.navigateByUrl('/campaigns');
    } catch (e: any) {
      this.error = e?.status === 401
        ? 'Email or password was not recognized. Please check both and try again.'
        : e?.status === 0
          ? 'Cannot reach the sign-in service. Check your connection and try again.'
          : e?.status === 429
            ? 'Too many sign-in attempts. Please wait and try again.'
            : 'Sign-in is unavailable right now. Please try again shortly.';
    } finally {
      this.busy = false;
    }
  }
}
